import { StatusBar } from "expo-status-bar"
import React from "react"
import { StyleSheet, View, Image } from "react-native"
import Constants from "expo-constants"
import Mascotte_v2_soignant from "@assets/icons/Mascotte_v2_soignant.png"
import Mascotte_v2_cpts from "@assets/icons/Mascotte_v2_cpts.png"
import { Button } from "@Components/CustomButton/Button"
import { BreeSerifText } from "@Components/CustomText/BreeSerifText"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { baseColors, baseFontSize, dimensions } from "@Constants/baseStyles"
import { Spacer } from "@Components/Space"
import { CustomScrollview } from "@Components/CustomScrollView/CustomScrollView"

const { platform } = Constants.expoConfig.extra
const isCpts = platform === "cpts"

const LandingPage = ({ navigation }) => {
    const gotoLogin = () => navigation.navigate("LoginStack")
    const mascoteImg = !isCpts ? Mascotte_v2_soignant : Mascotte_v2_cpts

    const WelcomeContent = () => {
        return (
            <View style={styles.container}>
                <CustomScrollview paddingBottom={50} contentContainerStyle={{ flexGrow: 1 }}>
                    <BreeSerifText fontSize={baseFontSize.lg * 1.1} textAlign={"center"} color={"white"}>
                        Bienvenue
                    </BreeSerifText>
                    <Spacer height={20} />
                    <OpenSansText fontSize={16} textAlign={"center"} color={"white"}>
                        IVEHTE est une application mobile d'éducation thérapeutique faite par des patients et des
                        soignants, à destination de patients atteints de pathologies chroniques.
                    </OpenSansText>
                    <View style={{ alignSelf: "center", justifyContent: "center" }}>
                        <Image
                            style={{
                                alignSelf: "center",
                                height: dimensions.fullHeight / 2.5,
                                maxWidth: dimensions.fullWidth / 1.2
                            }}
                            resizeMode={"contain"}
                            source={mascoteImg}
                            defaultSource={mascoteImg}
                        />
                    </View>

                    <OpenSansText fontSize={16} textAlign={"center"} color={"white"} style={{ marginBottom: 0 }}>
                        IVEHTE permet une prise en charge personnalisée et évolutive qui s'accorde à vos objectifs en
                        permanence, grâce à un suivi rapproché par des professionnels de santé.
                    </OpenSansText>

                    <Spacer height={20} />

                    <Button
                        onPress={gotoLogin}
                        text="Suivant"
                        width="70%"
                        // height={50}
                        backgroundColor="white"
                        labelColor={baseColors.green.primary}
                    />
                </CustomScrollview>
            </View>
        )
    }

    return (
        <View style={{ flex: 1 }}>
            <StatusBar translucent />
            {WelcomeContent()}
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        paddingTop: Constants.statusBarHeight * 2,
        flex: 1,
        paddingHorizontal: 20,
        justifyContent: "flex-start",
        backgroundColor: baseColors.green.primary
    }
})

export default LandingPage
